import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const fixedPhraseRepository = RepositoryFactory.get("fixedPhrase");
const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setFixedPhrase(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadFixedPhrase(context, payload) {
    const list = await fixedPhraseRepository.list(
      payload.screenId,
      payload.disasterNo
    );
    if (list.status < 300) {
      context.commit("setFixedPhrase", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
